import styled from 'styled-components'
import { device } from '../Breakpoints'

const Container = styled.div`
  display: flex;
  align-items: stretch;
  font-size: 14px;
  z-index: 9998;
  background: #f9f9f7;
  width: 100%;
  @media ${device.minLaptop} {
    position: fixed;
  }
  @media ${device.mobileL} {
    align-items: center;
    position: inherit;
  }
  .mobile {
    display: none;
  }
  .desktop {
    display: block;
  }
  .search {
    background: #ff8f8c;
    a {
      padding: 25px 24px;
      color: #ffffff;
      display: block;
    }
  }
  .logo {
    flex-grow: 1;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-around;
    max-width: 280px;
    min-width: 280px;

    @media ${device.mobileL} {
      justify-content: flex-start;
    }

    @media ${device.tablet} {
      flex-direction: column;
      max-width: 100%;
      flex: 1;
    }
    @media ${device.laptop} {
      flex-direction: column;
      max-width: 100%;
      min-width: 200px;
      flex: 1;
      .mobile {
        display: block;
        height: 75px;
      }
      .desktop {
        display: none;
      }
    }
    @media ${device.mobileS} {
      flex-direction: column;
      max-width: 100%;
      min-width: 200px;
      flex: 1;
      .mobile {
        display: block;
        height: 60px;
      }
    }
    @media ${device.laptopL} {
      flex-direction: row;
      max-width: 100%;
      min-width: 200px;
    }
    figure {
      margin: 0;
      @media ${device.mobileL} {
        margin: -10px 0 0;
      }
    }
  }
  .MobileTrigger {
    color: #148581;
    padding: 20px;
    display: none;
    @media ${device.mobileL} {
      display: block;
    }
    @media ${device.laptop} {
      display: flex;
      align-items: center;
    }
  }
  .SearchTrigger {
    background: #ff8f8c;
    color: #fff;
    padding: 30px 25px 30px 25px;
    display: none;
    @media ${device.mobileL} {
      padding: 0px 8px;
      min-height: 60px;
      margin-top: 2px;
      display: block;
    }
    @media ${device.laptop} {
      display: flex;
      align-items: center;
    }
    @media ${device.mobileS} {
      padding: 0px 6px;
      min-height: 50px;
      margin-top: 0px;
      margin-left: -20px;
      svg {
        width: 35px;
      }
    }
  }
  .navigation {
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    background: #e8f2ed;
    align-content: stretch;
    @media ${device.laptop} {
      display: none;
    }

    .social {
      li {
        a {
          padding: 0.2em;
          font-size: 1.5em !important;
          max-height: 20px;
        }
        a.whatsapp {
          padding: 0.15em 0.2em 0.2em 0.2em;
          svg {
            margin: 0 -2px 0 0;
          }
        }
      }
    }
  }
`

export default Container
